import { Image } from "antd";

const App = () => {
  return (
    <Image
      width={100 + "%"}
      src={require("../assets/banner.png")}
      preview={false}
      alt="1887-768"
    />
  );
};
export default App;
